
import React from 'react';
import AdminManagementPanel from '../components/AdminManagementPanel';
import BottomTabNavigation from '../components/navigation/BottomTabNavigation';

const AdminManagementPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1">
        <AdminManagementPanel />
      </div>
      <BottomTabNavigation />
    </div>
  );
};

export default AdminManagementPage;
